import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import {
    Avatar, Box, Button, Container, TextField, Typography
} from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import Copyright from 'components/common/Copyright';
import useAuth from 'hooks/useAuth';


const ForgotPassword = () => {
    const {t} = useTranslation();
    const {enqueueSnackbar} = useSnackbar();
    const {forgotPassword} = useAuth();
    const mailRef = useRef<HTMLInputElement>(null);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        forgotPassword(
            data.get('email') as string
        )
            .then(() => enqueueSnackbar(t('password_reset_link_sent'), {
                autoHideDuration: 2000,
                variant: 'success',
            }))
            .catch(() => mailRef.current!.value = '')
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Avatar sx={{m: 1, bgcolor: 'secondary.main'}}>
                    <LockOutlined/>
                </Avatar>
                <Typography mb={3}>
                    {t('forgot_password_description')}
                </Typography>
                <Box component="form" onSubmit={submit} sx={{mt: 1}}>
                    <TextField
                        margin="normal"
                        required
                        type="email"
                        fullWidth
                        id="email"
                        label={t('email_address')}
                        name="email"
                        autoComplete="email"
                        autoFocus
                        inputRef={mailRef}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                    >
                        {t('email_password_reset_link')}
                    </Button>

                </Box>
            </Box>
            <Copyright sx={{mt: 8, mb: 4}}/>
        </Container>
    );
};

export default ForgotPassword;
